import Button from '@/shared/Button';
import Div from '@/shared/Div';
import Image from '@/shared/Image';
import React, { Fragment, memo, useState } from 'react';
import PlayIcon from '../Icons/PlayIcon';
import { parseMediaFromCMS } from '@/utils/image';
import useScreen from '@/hooks/useScreen';
import Modal from '@/globalComponents/modal';
import CrossIcon from '../Icons/Cross';
import classNames from 'classnames';

function VideoCard({ title, mobileImage, desktopImage, video }: any) {
  const [play, setPlay] = useState(false);

  const togglePlay = () => {
    setPlay((p) => !p);
  };

  const { isDesktop } = useScreen();
  const { src } = parseMediaFromCMS(video);
  return (
    <Div className="flex flex-wrap border border-co-subtle rounded-cs max-w-screen-md md:mx-auto bg-white h-full">
      <Div
        className={classNames('relative w-full', {
          'h-full': !title,
        })}
      >
        <Image
          width={400}
          height={400}
          className={classNames('w-full rounded-t-cs object-cover ', {
            'h-full rounded-cs': !title,
          })}
          alt=""
          cmsImage={isDesktop ? desktopImage : mobileImage}
        />
        <Modal
          open={play}
          onClose={togglePlay}
          showHeader={false}
          renderHeader={() => null}
          modalClassNames={{
            modal: '!p-0 rounded-cs',
          }}
        >
          <Div className="relative  p-px rounded-cs bg-white">
            <video className="rounded-cs" width="906" autoPlay>
              <source src={src} type="video/mp4" />
              <source src={src} type="video/ogg" />
              Your browser does not support HTML video.
            </video>
            <Button
              className="absolute top-4 right-4 text-white"
              theme="none"
              track={false}
              dataTestId="close-icon"
              onClick={togglePlay}
            >
              <CrossIcon />
            </Button>
          </Div>
        </Modal>
        <Button
          theme="none"
          className="absolute inset-0 flex justify-center items-center"
          onClick={togglePlay}
          title="Play"
        >
          <PlayIcon />
        </Button>
      </Div>
      <Div className="py-8 px-6 text-h-3 md:text-hd-3 text-center w-full">{title}</Div>
    </Div>
  );
}

export default memo(VideoCard);
